import IDs_WHISP from '../../constants/IdsWhisp';

/**
 * IMPORTANT BEFORE UPDATING CODE!!!!
 * ANY CHANGE IN THIS FILE SHOULD BE DONE IN sirio_app AND sirio_admin equally to avoid errors.
 * VERSION 1.0
 */

/**
 * Calcula el riesgo de eudr
 * @param {number} poligono
 * @param {number} id_riesgo_eudr_user
 * @param {number} alertas_error_poligono_count
 * @param {number} id_riesgo_eudr_whisp
 * @param {number} areas_naturales_count
 * @returns {number}
 */

const riesgoEudrCalculator = (poligono, id_riesgo_eudr_user, alertas_error_poligono_count, id_riesgo_eudr_whisp, areas_naturales_count) => {
  if (poligono != 1) return IDs_WHISP.SIN_ASIGNAR;
  if (id_riesgo_eudr_user) {
    if (id_riesgo_eudr_user == IDs_WHISP.ALTO || id_riesgo_eudr_user == IDs_WHISP.BAJO) {
      return id_riesgo_eudr_user;
    }
    return IDs_WHISP.MEDIO;
  }
  if (id_riesgo_eudr_whisp == IDs_WHISP.ALTO) return IDs_WHISP.ALTO;
  if (id_riesgo_eudr_whisp == IDs_WHISP.BAJO && alertas_error_poligono_count == 0 && areas_naturales_count == 0) return IDs_WHISP.BAJO;
  return IDs_WHISP.MEDIO;
};

export default riesgoEudrCalculator;
